import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Route } from 'react-router-dom'

import { Navbar, Sidebar } from '../../components'
import { GlobalContextProvider } from '../../contexts/GlobalContext'
import './Main.css'
import Home from './Home/Home'
import Sistema from './Sistema/Sistema'
import Cadastros from './Cadastros/Cadastros'
import Picking from './Picking/Picking'
import Entrega from './Entrega/Entrega'
import OrdemColeta from './OrdemColeta/OrdemColeta'
import Dashboard from './Dashboard/Dashboard'
import Patrimonio from './Patrimonio/Patrimonio'
import Insumo from './Insumo/Insumo'
import Documentacao from './Documentacao/Documentacao'
import Estoque from './Estoque/Estoque'
import Patio from './Patio/Patio'
import ChecklistOperacional from './ChecklistOperacional/ChecklistOperacional'
import Fiscal from './Fiscal/Fiscal'

class Main extends Component {
  render() {
    const {
      system: { showSidebar },
    } = this.props
    const mainSidebarClass = showSidebar ? 'Main__sidebar sidebar__active' : 'Main__sidebar'

    return (
      <GlobalContextProvider>
        <div className="Main">
          <div className={mainSidebarClass}>
            <Sidebar />
          </div>
          <div className="Main__wrapper">
            <div className="Main__navbar">
              <Navbar />
            </div>
            <main className="bck-cinza">
              <Route path="/main/home" component={Home} />
              <Route path="/main/documentacao" component={Documentacao} />
              <Route path="/main/dashboard" component={Dashboard} />
              <Route path="/main/sistema" component={Sistema} />
              <Route path="/main/cadastros" component={Cadastros} />
              <Route path="/main/picking" component={Picking} />
              <Route path="/main/entregas" component={Entrega} />
              <Route path="/main/ordemcoleta" component={OrdemColeta} />
              <Route path="/main/patrimonio" component={Patrimonio} />
              <Route path="/main/insumo" component={Insumo} />
              <Route path="/main/estoque" component={Estoque} />
              <Route path="/main/patio" component={Patio} />
              <Route path="/main/checklist-operacional" component={ChecklistOperacional} />
              <Route path="/main/fiscal" component={Fiscal} />
            </main>
          </div>
        </div>
      </GlobalContextProvider>
    )
  }
}

const mapStateToProps = ({ system }) => ({ system })

export default connect(mapStateToProps)(Main)
